import React  from 'react'

const BkFlowEditAddRoomsToggleSelect = props => {
  const {
    currentRooms,
    flowQueryConfig,
    hotelLabels,
    updateRoomsEvent,
  } = props

  const totalRooms = Number(flowQueryConfig.maximumRooms) ? Number(flowQueryConfig.maximumRooms) : 10
  const roomOptions = []

  for (let i = 1; i <= totalRooms; i++) {
    roomOptions.push(
      <option
        key={`guest-room-${i}`}
        value={i}
      >
        {i}
      </option>
    )
  }

  return (
    <div className="bk-flow-edit-guest__rooms-select">
      <label>{hotelLabels.widgetGuestRooms ? hotelLabels.widgetGuestRooms : 'Rooms'}</label>
      <div className="bk-flow-edit-guest__rooms-select-field">
        <select
          className="u-form__select"
          onChange={(e) => updateRoomsEvent(e.target.value)}
          value={currentRooms}
        >
          {roomOptions}
        </select>
        <span className="bk-flow-edit-guest__property-arrow"></span>
      </div>
    </div>
  )
}

export default BkFlowEditAddRoomsToggleSelect



// WEBPACK FOOTER //
// ./src/components/edit/guest/layouts/BkFlowEditAddRoomsToggleSelect.js